module.exports = __webpack_public_path__ + "img/male-bg-white.8260eb87.svg";